import React from 'react';

import validate from '../../utilities/control.validate';

const SelectControl = ({
  classes = 'form-control form-control-sm ', submitted = false,
  value = '', options, onChange
}) => {
  let { id, label, name, choises, readonly = false, rules } = options;
  let inputRequired = false;

  if ( rules && rules.isRequired ) inputRequired = true;

  let valid = {
    isValid: true,
    validateMessage: ''
  };
  if ( submitted ) valid = validate(value, rules);

  classes += !valid.isValid ? ' is-invalid' : '';

  return (
    <div className="form-group">
      {
        label &&
        <label htmlFor={id}>
          {label}
          {inputRequired && <span>&nbsp;*</span>}
        </label>
      }
      <select
        className={classes}
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        required={inputRequired}
        disabled={readonly}
      >
        {
          choises.map((item, index) => (
            <option
              key={index}
              value={item.value}
            >{item.label}</option>
          ))
        }
      </select>
      {
        valid.validateMessage &&
        <div className="invalid-feedback">{valid.validateMessage}</div>
      }
    </div>
  )
}

export default SelectControl;